// Row component used by the mapping function in FuelTable.js
import React from 'react';
import { MdDeleteForever } from "react-icons/md";

/**
 * **********************************************************
 * Formatting region 
 * **********************************************************
 */
const fmt1 = (x) => (Number.isFinite(Number(x)) ? Number(x).toFixed(1) : "");
const fmt0 = (x) => (Number.isFinite(Number(x)) ? Number(x).toFixed(0) : "");
const fmtSigned0 = (v) => {
  const n = Number(v);
  if (!Number.isFinite(n)) return "";
  const s = n > 0 ? "+" : "";      // keep '-' automatically
  return s + n.toFixed(1);
};


// ---------------------------
  // Flight Planning row 
  // uses ? the ternary operator to avoid displaying NaN for empty fields
  // uses ?? the coalescing operator to handle null/undefined values
  // ---------------------------
function PlanRow({
  plan, 
  index, 
  onEdit, 
  onDelete, 
  disableDelete,
  stationList = [],
}) {
    console.log("PlanRow function LOADED");
    const windText =
            plan.windDir !== "" || plan.windSpd !== ""
            ? `${fmt0(plan.windDir)}° / ${fmt1(plan.windSpd)}`
            : "";

  const cellInput = (field, className="navlog-input") => (
    <input
       className={className}
      value={plan[field] ?? ""}
      onChange={(e) => onEdit(index, field, e.target.value)}
    />
  );
  console.log("HW/CW", plan.checkpoint, plan.hw, plan.cw);

  return (
    <tr>
       <td className="navlog-ft-col">
        <input
          className="navlog-input-ft"
          value={plan.ft ?? ""}
          onChange={(e) => onEdit(index, "ft", e.target.value.toUpperCase())}
        /> 
      </td>
      
      <td className="navlog-checkpoint-col">
        <input
          className="navlog-checkpoint-input"
          value={plan.checkpoint ?? ""}
          onChange={(e) => onEdit(index, "checkpoint", e.target.value)}
        />
      </td>
      <td className="navlog-cruisealt-col">{cellInput("cruiseAlt")}</td>
      <td className="navlog-cas-col">{cellInput("cas")}</td>
      <td className="navlog-tc-col">{cellInput("tc")}</td>
      <td className="navlog-nm-col">{cellInput("nm")}</td>
      <td className="navlog-gph-col">{cellInput("gph")}</td>
      <td className="navlog-mdev-col">{cellInput("mdev")}</td>
      <td className="navlog-cdev-col">{cellInput("cdev")}</td>


      <td className="navlog-tas-col navlog-output">{fmt1(plan.tas)}</td>
      <td className="navlog-wind-col navlog-output">{windText}</td>
      <td className="navlog-wca-col navlog-output">{fmt1(plan.wca)}</td>
      <td className="navlog-th-col navlog-output">{fmt1(plan.th)}</td>
      
      <td className="navlog-ch-col navlog-output">{fmt1(plan.ch)}</td>
      <td className="navlog-gs-col navlog-output">{fmt1(plan.gs)}</td>
      <td className="navlog-ete-col navlog-output">{fmt1(plan.eteMin)}</td>
      <td className="navlog-gal-col navlog-output">{fmt1(plan.galsUsed)}</td>

      <td className="navlog-hw-col navlog-output">
          {Number.isFinite(Number(plan.hw)) ? fmtSigned0(plan.hw) : ""}
        </td>

        <td className="navlog-cw-col navlog-output">
          {Number.isFinite(Number(plan.cw)) ? fmtSigned0(plan.cw) : ""}
        </td>
      

      <td className="navlog-delete-col">
         <MdDeleteForever
          title="Delete row"
          onClick={() => onDelete(index)}
          className={`navlog-delete-icon ${disableDelete ? "is-disabled" : ""}`}
          style={{
            cursor: disableDelete ? "not-allowed" : "pointer",
            opacity: disableDelete ? 0.35 : 1,
            pointerEvents: disableDelete ? "none" : "auto",
          }}
        />
      </td>
    </tr>
  );
}

export default PlanRow;
